import { Component, OnDestroy, OnInit } from "@angular/core";
import * as _ from "lodash";
import { forkJoin, Observable } from "rxjs";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../core/services/event-bus.service";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { AuthorizationService } from "../../shared/services/authorization.service";
import { SharedDataService } from "../../shared/sharedData.service";

@Component({
    selector: "dashboard-layout",
    templateUrl: "./dashboard-layout.component.html",
    standalone: false,
})
export class DashboardLayoutComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBus: EventBusService,
        private authService: AuthorizationService,
        private _sharedDataService: SharedDataService,
        private _eventBusService: EventBusService,
        private log: NbcLoggerService
    ) {}

    private subs = new SubSink();
    selectedBusinessUnit: any;
    BuAccess: any;
    departments: any;
    operationTalentDept: any;
    financePayrollDept: any;
    selectedDepartmentId: any;
    businessUnits: any;
    permitsPayrollExport: any;
    permitsPayrollSu: any;
    permitsTalentSu: any;
    showPayrollExport: boolean;
    showBUManageTCSection: boolean;
    showBUManageOnboardingSection: boolean;

    DepartmentsWithTimesheets = ["SUBMITTER", "APPROVER"];
    DepartmentsWithTimecards = ["FINANCE", "PAYROLL"];

    subscribeEventHandlers() {
        this.subs.sink = this._eventBus.on(
            "onBusinessUnitsReceived1",
            (data) => (this.businessUnits = data)
        );
        this.subs.sink = this._eventBus.on("onBusinessUnitSelected", (data) =>
            this.onBusinessUnitSelected(data)
        );
    }

    onBusinessUnitSelected(data) {
        this.financePayrollDept = false;
        this.operationTalentDept = false;

        if (!data) return;

        this.selectedBusinessUnit = data;
        const buId = this.selectedBusinessUnit.id;
        const userBuAccess$ = this.authService.getBUAccess(buId);
        const userPermission$ = this.authService.getUserPermissions(buId);
        this.departments = _.find(this.businessUnits, { id: buId }).departments;

        this._sharedDataService.setSelectedBusinessUnit(
            this.selectedBusinessUnit
        );

        forkJoin(userBuAccess$, userPermission$).subscribe(
            ([buAccess, permission]) => {
                this.userAccessForBU(buAccess);
                this.talentUserPermissions(permission);
            }
        );
    }

    talentUserPermissions(result: any) {
        this.permitsPayrollExport = _.find(result?.reference?.userRoles, {
            description: "Payroll Export SU",
        });
        this.permitsPayrollSu = _.find(result?.reference?.userRoles, {
            description: "Payroll SU",
        });

        this.permitsTalentSu = _.find(result?.reference?.userRoles, {
            description: "Talent SU",
        });

        if (_.isUndefined(this.permitsPayrollExport)) {
            this.showBUManageTCSection = false;
        } else {
            this.showBUManageTCSection = true;
        }

        if (
            this.permitsTalentSu ||
            this.permitsPayrollSu
        ) {
          this.showBUManageOnboardingSection = true;
        } else {
          this.showBUManageOnboardingSection = false;
        }

        if (
            !_.isUndefined(this.permitsPayrollExport) ||
            !_.isUndefined(this.permitsPayrollSu)
        ) {
            this.showPayrollExport = true;
        } else {
            this.showPayrollExport = false;
        }

        if (this.showPayrollExport) {
            this._eventBusService.emit(
                new EmitEvent("reloadStudioPayroll", "reloadStudioPayroll", "")
            );
        }
    }

    userAccessForBU(result: any) {
        this.BuAccess = result.reference;

        if (this.BuAccess) {
            this.financePayrollDept = _.includes(
                this.DepartmentsWithTimecards,
                this.BuAccess.department
            );
            this.selectedDepartmentId = this.BuAccess.departmentId;
            this._sharedDataService.setBuAccess(this.BuAccess);

            setTimeout(() => {
                this.operationTalentDept = _.includes(
                    this.DepartmentsWithTimesheets,
                    this.BuAccess.department
                );
            }, 300);
        }
    }

    ngOnInit() {
        this._sharedDataService.setCss("dashboard");
        this.subscribeEventHandlers();
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
